module.exports = __webpack_public_path__ + "static/media/youtube.76ec9c6c.png";